import { PREVIEW_ELEMENT } from '@/constants/preview'
const ELEMENTS = {
  /**
   * @description 视频播放课程内容
   */
  VIDEO: [
    800, 804, 805, 806, 807, 808, 809, 810, 811, 812, 813, 814, 823, 826, 832,
    833, 834,
  ],
  /**
   * @description 音频播放课程内容
   */
  AUDIO: [801, 827, 829, 830],
  /**
   * @description ABC选项测评
   * 题干：音频+图片
   * 答题：ABC选项
   * 答案：音频
   */
  ABC_OPTIONS_TEST: [802],
  /**
   * @description 听读（掌门演讲）
   * 题干：音频+图片
   * 答题：录音
   * 答案：无
   */
  AUDIO_READ: [831],
  /**
   * @description 语音测评
   * 题干：音频+图片
   * 答题：录音
   * 答案：音频
   */
  AUDIO_TEST: [803, 820],
  /**
   * @description 跟读测评
   * 题干：视频
   * 答题：语音
   * 答案：无
   */
  LISTEN_REPEAT_TEST: [815, 824],
  /**
   * @description 自读测评
   * 题干：视频（静音）
   * 答题：语音
   * 答案：无
   */
  SELF_READING_TEST: [816, 825],
  /**
   * @description 试卷
   * 中、英整考/章考测评
   */
  EXAM: [817, 818, 828],
  /**
   * @description 整讲测评/扩展
   * 题干：视频
   * 答题：录音
   * 答案：视频/无
   */
  EXPLAIN_TEST: [819, 822],
  /**
   * @description ABC讲解测评
   * 题干：视频+图片
   * 答题：录音答题
   * 答案：视频
   */
  ABC_EXPLAIN_TEST: [821],
  /**
   * @description 正答文本图片
   * 多张图片展示课件内容
   */
  PICTURES: [835],
  /**
   * @description 整听
   */
  PREVIEW_AUDIO: [PREVIEW_ELEMENT.AUDIO],
  /**
   * @description 整提示
   */
  STUDY_MESSAGE: [PREVIEW_ELEMENT.TIPS],
  /**
   * @description 整看
   */
  PREVIEW_VIDEO: [PREVIEW_ELEMENT.VIDEO],
  /**
   * @description 读音游戏
   */
  PRONUNCIATION_GAME: [836],
  /**
   * @description 指读
   */
  POINT_READ: [837],
  /**
   * @description 默读
   */
  SILENCE_READ: [838],
  /**
   * @description 听音排图
   */
  AUDIO_SORT: [839],
  /**
   * @description 讲解与理解
   */
  EXPLAIN_AND_UNDERSTAND: [840],
}

export default {
  // ...ELEMENTS,
  data() {
    return {
      ...(() => {
        const SOURCE_TO_ELEMENT = {} // 资源类型对照10大功能元素 800:VIDEO
        const ELEMENT_TYPES = {} // 10大功能元素常量值 VIDEO:"VIDEO"
        Object.keys(ELEMENTS).forEach((key) => {
          Object.defineProperty(ELEMENT_TYPES, key, {
            value: key,
            writable: false,
          })
          ELEMENTS[key].forEach((ii) => {
            Object.defineProperty(SOURCE_TO_ELEMENT, ii, {
              value: key,
              writable: false,
            })
          })
        })

        return { SOURCE_TO_ELEMENT, ELEMENT_TYPES }
      })(),
    }
  },
}
